// Custom accept terms and conditions check
document.addEventListener("DOMContentLoaded", function() {
    document.body.addEventListener("click", function(event) {
        if (event.target.matches('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
          
            var checkbox = document.getElementById("agree");
            var checkboxCart = document.getElementById("agree-cart");
            
            // Check if the checkboxes exist and if either of them is checked
            var isAgreeChecked = checkbox ? checkbox.checked : false;
            var isAgreeCartChecked = checkboxCart ? checkboxCart.checked : false;

            if (!isAgreeChecked && !isAgreeCartChecked) {
                alert("Bitte akzeptieren Sie die Bedingungen und Konditionen.");
                event.preventDefault();
            }
        }
    });
});